export default "__VITE_ASSET__C9$mOs00__"